import { WpEtEnrollment } from './wp-et-enrollment.model';
import { WpNonCompliance } from './wp-non-compliance.model';

export class NonCompliance {
    constructor(
        public personId?: number,
        public referralId?: number,
        public serviceCounty?: number,
        public providerId?: number,
        public nonCoopId?: number,
        public wpNonCompliance?: WpNonCompliance,
        public wpEtEnrollment?: WpEtEnrollment,
        public recordVersion?: number,
        public duplicate?: boolean,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/non-compliance.model.ts